import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  ComponentData,
  GetComponentQueryKey,
  UseGetComponentParams,
} from './types';
import { getComponentQueryKey } from './util';

export const useGetComponent: QueryFunction<
  ComponentData,
  [UseGetComponentParams],
  GetComponentQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  const queryKey = getComponentQueryKey(params);

  return useQuery<ComponentData, unknown, ComponentData, GetComponentQueryKey>({
    enabled: !!params.componentId,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/quotes/components/${params.componentId}`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
    ...queryOptions,
  });
};
